var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniCulture04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.71875,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D6895E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_15841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.71875,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#5292A7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_15841)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.719,
    y: 180.99,
    width: 113.127,
    height: 26.4786,
    fill: "#1F263E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.719 180.995H242.846L236.417 165.986H136.148L129.719 180.995Z",
    fill: "#7083C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.883 59.4941H200.679V73.9946H171.883V59.4941Z",
    fill: "#354990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.883 158.09H200.679V172.59H171.883V158.09Z",
    fill: "#354990"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.281,
    cy: 172.592,
    rx: 14.3981,
    ry: 3.78333,
    fill: "#354990"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.679 73.8942C200.679 65.9424 194.233 59.4961 186.281 59.4961V59.4961C178.329 59.4961 171.883 65.9424 171.883 73.8942V77.1538C171.883 84.2621 167.024 90.2814 160.89 93.8749C148.103 101.367 139.646 114.355 139.646 129.122C139.646 152.326 160.526 171.136 186.282 171.136C212.039 171.136 232.918 152.326 232.918 129.122C232.918 114.354 224.461 101.366 211.673 93.8738C205.539 90.2804 200.679 84.261 200.679 77.1522V73.8942Z",
    fill: "#354990"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.281,
    cy: 59.4943,
    rx: 14.3981,
    ry: 3.78333,
    fill: "#425BB2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.283,
    cy: 59.4922,
    rx: 12.3514,
    ry: 2.67583,
    fill: "#1B2753"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.719,
    y: 61.9375,
    width: 113.127,
    height: 119.052,
    fill: "#A4AFD6",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.519 180.99L142.092 61.9375H162.193L188.558 180.99H169.519Z",
    fill: "#D5D0F1",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.751 180.99L165.324 61.9375H169.996L196.361 180.99H192.751Z",
    fill: "#D5D0F1",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.719 61.9393H242.846L235.131 50.3887H137.434L129.719 61.9393Z",
    fill: "#A4AFD6",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.387 242.311V222.514H190.152C194.65 222.514 197.234 225.289 197.234 229.186C197.234 233.137 194.609 235.857 190.043 235.857H186.488V242.311H182.387ZM186.488 232.549H189.387C191.82 232.549 193.01 231.182 192.996 229.186C193.01 227.217 191.82 225.891 189.387 225.877H186.488V232.549ZM201.199 242.557C199.914 242.557 198.875 241.531 198.902 240.26C198.875 239.002 199.914 237.977 201.199 237.99C202.416 237.977 203.469 239.002 203.469 240.26C203.469 241.531 202.416 242.557 201.199 242.557ZM206.805 242.311V222.514H214.57C219.068 222.514 221.652 225.289 221.652 229.186C221.652 233.137 219.027 235.857 214.461 235.857H210.906V242.311H206.805ZM210.906 232.549H213.805C216.238 232.549 217.428 231.182 217.414 229.186C217.428 227.217 216.238 225.891 213.805 225.877H210.906V232.549ZM228.215 222.514V242.311H224.168V222.514H228.215ZM238.086 242.611C233.533 242.598 230.744 239.658 230.758 234.955C230.744 230.375 233.574 227.271 237.922 227.271C241.818 227.271 244.895 229.732 244.895 234.791V235.939H234.75C234.75 238.182 236.076 239.562 238.168 239.576C239.549 239.562 240.533 238.961 240.93 238.072H244.785C244.211 240.82 241.75 242.598 238.086 242.611ZM234.75 233.396H241.066C241.053 231.592 239.809 230.293 238.004 230.307C236.145 230.293 234.832 231.688 234.75 233.396Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCulture04);
export default __webpack_public_path__ + "static/media/mini_culture_04.3813c06c24b3c5321323bb88a1a5e0ec.svg";
export { ForwardRef as ReactComponent };